import React from 'react';

import BnplFormContainer from './BnplFormContainer';

import { getTenant } from '../../config';

export const renderBnplLayout = (children) => {
  if (getTenant() === 'lightrx') {
    return (
      <BnplFormContainer isDesktop={true}>
        <div className="payment-wrapper">{children}</div>
      </BnplFormContainer>
    );
  } else {
    return <>{children}</>;
  }
};
